import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { College } from '../../requets/shared/model/college.model';
import { RequestService } from '../../requets/shared/request.service';
import { FilterRequestEvaluated } from '../shared/filter-request-evaluated.model';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { SelectCollageDialogComponent } from 'src/app/core/modal/select-collage-dialog/select-collage-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-search-fields-reports',
  templateUrl: './search-fields-reports.component.html',
  styleUrls: ['./search-fields-reports.component.scss']
})
export class SearchFieldsReportsComponent implements OnInit {

  fechaInicial: Date;
  fechaFinal: Date;
  selectedCollage: String;
  programa: String;
  materia: String;
  cedula: string;
  selectedType: String = 'MATERIA REGULAR';

  colleges: College[];
  date = new Date();

  enabledSpinner = false;
  filterRequest: FilterRequestEvaluated;


  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();

  constructor(private requestService: RequestService, private dialog: MatDialog) { }



  ngOnInit() {
    this.getColleges();
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { collages: this.colleges};
    dialogConfig.width = '50%';
    const dialogRef = this.dialog.open(SelectCollageDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          this.selectedCollage = value.college.codigo  + ' - ' + value.college.nombre;
        }
    });
  }

  sendSearchParam() {
    if (this.selectedType !== '' ) {
      this.filterRequest = new FilterRequestEvaluated();
      this.filterRequest.fechaInicial = !this.fechaInicial ? null : this.fechaInicial;
      this.filterRequest.fechaFinal = !this.fechaFinal ? null : this.fechaFinal;
      this.filterRequest.institucion = !this.selectedCollage ? null : this.selectedCollage;
      this.filterRequest.programa = !this.programa ? null : this.programa;
      this.filterRequest.materia = !this.materia ? null : this.materia;
      this.filterRequest.cedula = !this.cedula ? null : this.cedula;
      this.filterRequest.tipo = !this.selectedType ? null : this.selectedType;
      if (this.selectedType === '') {
        this.filterRequest.tipo = 'MATERIA REGULAR';
      } else {
        this.filterRequest.tipo = this.selectedType;
      }
      this.sendSearchRequest.emit(this.filterRequest);
    } else {
      // enviar mensaje de que debe seleccionar un tipo de solicitud
    }
  }

  private getColleges() {
    this.requestService.getColleges().subscribe(
      (result) => {
        if (result.data !== []) {
          this.colleges = result.data  as College[];
        }
      }
    );
  }

  clean() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      tittle: 'Mensaje Confirmación',
      message:
        '¿Esta seguro que desea limpiar los filtros?'
    };
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig );
    dialogRef.afterClosed().subscribe(value => {
      if (value === 1) {
        this.filterRequest = new FilterRequestEvaluated();
        this.fechaInicial = null;
        this.fechaFinal = null;
        this.selectedCollage = null;
        this.programa = null;
        this.materia = null;
        this.cedula = null;
        this.selectedType = 'MATERIA REGULAR';
      }
    });
  }

}
